import React from 'react';
import styled, { css } from 'styled-components';

export const FieldContainer = styled.div.withConfig({ componentId: 'sc-1tq6cjq-0' })<{ error: boolean }>`
  position: relative;
  border-left: 2px solid #e7e7e7;
  border-right: 2px solid #e7e7e7;

  &:not(last-child) {
    border-bottom: 1px solid #e7e7e7;
  }

  &:first-child {
    border-top-right-radius: 4px;
    border-top-left-radius: 4px;
    border-top: 2px solid #e7e7e7;
  }
  &:last-child {
    border-bottom-right-radius: 4px;
    border-bottom-left-radius: 4px;
    border-bottom: 2px solid #e7e7e7;
  }
  ${({ error }) => css`
    ${error ? 'border: 1px solid #ff9494 !important' : ''};
  `}
`;
